<div class="grid grid--gap-8 grid--va-middle">
  <div class="grid__box grid__box--size-min" *ngFor="let last = last; let breadcrumb; of: currentBreadcrumbs">
    <a routerLink="{{ breadcrumb.url }}" *ngIf="breadcrumb.url" class="link"
      ><b>{{ breadcrumb.text }}</b></a
    >
    <b class="color-blue-dark" *ngIf="!breadcrumb.url">{{ breadcrumb.text }}</b>
    <b>{{ last ? '' : ' : ' }}</b>
  </div>
</div>
